export const EmployeeRoutes = {
  GET_END_EMPLOYMENT_REASONS: '/employee/end-employment-reasons',

  BASE: '/employee',
  getBaseRoute: (employeeId?: number) => `${EmployeeRoutes.BASE}/${employeeId || ':employeeId'}`,

  EMPLOYEE: '/',
  MESSAGES: '/messages',
};
